<div [style.background-color]="backgroundColorScreen">
    <div class="agGridOuterDiv1">
      <div>
        <mat-toolbar
          class="agGridtoperDiv card"
          style="
            background: rgb(228 227 230 / 41%);
            border-top: 1px solid #a9a9a9a8;
            border-right: 1px solid #a9a9a9a8;
            border-left: 1px solid #a9a9a9a8;
          "
        >
          <label i18n="@@spmsUserReg" class="textColour">Object Changes</label>
          <span class="example-spacer"></span>

          
           

        
         
        <button i18n="@@TMRunButton" type="button" (click)="onBtExport()" [style.background-color]="backgroundColorButton"
        class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;" [style.border-color]="backgroundColorButton">Download <em
        style="padding: 0px 0px 0px 10px"
        class="fas fa-download example-icon"
        title="Download"
      ></em></button>  

  
          <div class="insertPageNoDiv" style="width: 6.5%">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@Targetpageno">Page No</mat-label>
              <input
                matInput
                type="text" 
                (input)="onSearchChange($event.target.value)"
              />
            </mat-form-field>
          </div>
          <div class="selectRecordsDiv" style="width: 8%">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label i18n="@@Targetrecords" style="color: black"
                >Records</mat-label
              >
              <mat-select
                [(ngModel)]="pageSize"
                (ngModelChange)="onPageSizeChanged(value)"
              >
                <mat-option value="10" selected>10</mat-option>
                <mat-option value="200">200</mat-option>
                <mat-option value="300">300</mat-option>
                <mat-option value="400">400</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div
            class="card pagination paginationFirstButton paginationFirstlastButton"
          >
            <em
              class="fas fa-angle-double-left waves-effect waves-light"
              (click)="onBtFirst()"
            ></em>
          </div>
          <div class="card pagination paginationButtons btn-rounded">
            <ul>
              <li class="paginationliicon">
                <em
                  class="fas fa-angle-left waves-effect waves-light"
                  (click)="onBtPrevious()"
                ></em>
              </li>
              <li>{{ currentPage }}/{{ totalPages }}</li>
              <li class="paginationliicon" style="padding: 0; margin-right: 5px">
                <em
                  class="fas fa-angle-right waves-effect waves-light"
                  (click)="onBtNext()"
                ></em>
              </li>
            </ul>
          </div>
          <div
            class="card pagination paginationLastButton paginationFirstlastButton"
          >
            <em
              class="fas fa-angle-double-right waves-effect waves-light"
              (click)="onBtLast()"
            ></em>
          </div>
        </mat-toolbar>
      </div>
  
      <div>
        <ag-grid-angular
          class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin agGridOuterDiv1"
          [columnDefs]="columnDefs"
          [animateRows]="true"
          [pagination]="true"
          [rowSelection]="rowSelection"
          [defaultColDef]="defaultColDef"
          [suppressPaginationPanel]="true"
          [rowHeight]="35"
          [headerHeight]="35"
          [enableBrowserTooltips]="true"
          [floatingFiltersHeight]="45"
          [paginationPageSize]="paginationPageSize"
          [paginationNumberFormatter]="paginationNumberFormatter"
          [enableRangeSelection]="true"
          [debug]="true"
          [rowClassRules]="rowClassRules"
          (paginationChanged)="onPaginationChanged()"
          (gridReady)="onGridReady($event)"
          [hidden]="!true"
          [gridOptions]="gridOptions"
        ></ag-grid-angular>
      </div>
    </div>
  </div>
  
  <div class="col-lg" style="margin-top: 50px;">
      <div class="container" style="text-align: center;">
        <div class="row topRowMargins">
  
          <div class="col-lg">
  
            <div style="text-align: end">
                <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="margin-left: 10px; width: 160px;height: 20px;text-align: center;display: flex; justify-content: center; align-items: center" [style.background-color]="backgroundColorButton" title="Detect Changes" (click) = "bringChangesFromVault()" >Bring Changes<em  title="Bring Changes"></em></button> -->

                <!-- <button i18n="@@TMRunButton" type="button" [style.background-color]="backgroundColorButton"
                class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;"  (click) = "importChanges()" [style.border-color]="backgroundColorButton">Import Changes</button>    
             -->
              <button i18n="@@TMRunButton" type="button" (click)="cancel()" [style.background-color]="backgroundColorButton"
              class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;" [style.border-color]="backgroundColorButton">Close</button>  
  
            </div>
  
          </div>
  
        </div>
      </div>
    </div>
  